import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import defaultImg from '../../asset/project/default_1.png';
import deleteIcon from '../../asset/icon/delete.png';
import { SelectedData } from '../../shared/dto/EntityRepository';
import { useImportStationWorkStore } from '../../shared/store/importStationWorkStore';
import { useOptimizedImageUrl } from '../../shared/hooks/useOptimizedImageUrl';

interface SelectedDataThumbProps {
  item: SelectedData;
}

const SelectedDataThumb: React.FC<SelectedDataThumbProps> = ({ item }) => {
  const [isHover, setIsHover] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const { removeSelectedData } = useImportStationWorkStore();
  const imageUrl = useOptimizedImageUrl(item.originUrl ?? '', containerRef);

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    removeSelectedData(item);
  };

  return (
    <ThumbWrapper
      ref={containerRef}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <SelectedThumb
        $isHover={isHover}
        src={imageUrl === '' ? defaultImg : imageUrl}
        alt=""
      />
      <HoverOverlay
        $isHover={isHover}
        onClick={handleRemove}
      >
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent={true}
          backgroundImg={deleteIcon}
          onClick={handleRemove}
          aria-label="Remove selected item"
        />
      </HoverOverlay>
    </ThumbWrapper>
  );
};

const ThumbWrapper = styled.div`
  position: relative;
  height: 100%;
  flex-shrink: 0;
`;

const SelectedThumb = styled.img<{ $isHover: boolean }>`
  height: 100%;
  width: auto;
  object-fit: contain;
  display: block;
  filter: ${({ $isHover }) => ($isHover ? 'blur(2px)' : 'none')};
  transition: filter 0.2s ease;
`;

const HoverOverlay = styled.div<{ $isHover: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isHover }) => ($isHover ? 1 : 0)};
  transition: opacity 0.2s ease;
  cursor: pointer;
`;

export default SelectedDataThumb;
